module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "ch01"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p5"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chicohenmove0005#toc"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Hallways and Airwaves:")]), _vm._v(" "), _c('h1', {
    staticClass: "cs"
  }, [_vm._v("Changing Neighborhoods and Emerging Media Inspire New Music")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "data-locator": "p5"
    }
  }), _vm._v("Sometime in early 1958, five singers and their manager navigated a stretch of Chicago’s South Michigan Avenue known as Record Row. Confident, persistent, and with nothing to lose, they hoped that one of the equally undaunted companies lining the street would change their fortunes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en2",
      "id": "en2r"
    }
  }, [_vm._v("1")])]), _vm._v(" Had they traveled the entire mile and a half of the street, they would have ambled from Roosevelt Road on the north to East Twenty-Fifth Street on the south."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en3",
      "id": "en3r"
    }
  }, [_vm._v("2")])]), _vm._v(" Collectively known as the Impressions, these vocalists, in their late teens and early twenties, were from the Cabrini-Green public housing project on the North Side. Curtis Mayfield was not yet sixteen. Decades later, he recalled snow up to their necks that Saturday morning. But it proved little hindrance as he carried his guitar and amplifier down the street."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en4",
      "id": "en4r"
    }
  }, [_vm._v("3")])]), _vm._v(" Eddie Thomas, the group’s manager, came from the South Side. He was about ten years older, and his education in the music business combined street smarts with improvisation. They recalled that their first stop was a company called King, but its roster was full. Then they called on Chess Records—same response. Next they approached a record company named Vee-Jay on the other side of the street.")]), _vm._v(" "), _c('p', [_vm._v("“We went over there, and I introduced myself to Calvin Carter, who was the A&R director at the time,” Thomas recalled. “I told him I’d like to bring my group over. So we set up a date to bring them in. And we went back over to Vee-Jay Records; a cold winter night too. Snow on the ground. And we did a couple songs and he said, ‘Man, your group is sounding good.’ And I said to Curtis, ‘Go and do “For Your Precious Love.”’ We did one take. Where’s the contract? OK, they signed us up.”")]), _vm._v(" "), _c('p', [_vm._v("As Jerry Butler remembered it, their interests were to be heard and not to be cheated. Almost fifty years later he recalled, “We just wanted to see if "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p6"
    }
  }), _vm._v("someone would listen to our songs without a [hidden] tape recorder going in the drawer.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en5",
      "id": "en5r"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', [_vm._v("This sequence of events and its aftermath—a hit song, international fame for the group, and solo careers for Butler and Mayfield—plays out like the kind of life-defining moment confirmed through collective memories. Legends do tend to conflict with other published narratives,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en6",
      "id": "en6r"
    }
  }, [_vm._v("5")])]), _vm._v(" but several singers, instrumentalists, and producers who grew up in Chicago at that time experienced similar moments. Some of these artists and producers worked on or near Record Row, others worked throughout the city. Many of them lived through the circumstances that led to the recording of such songs as the Impressions’ “For Your Precious Love.” Major social shifts ran underneath that tune’s four chords, Mayfield’s lyrical guitar lead, and the group’s incantatory harmonies.")]), _vm._v(" "), _c('p', [_vm._v("Those harmonies convey understated power. No big vocal leaps or instrumental flourishes were needed to make “For Your Precious Love” a departure from the doo-wop that came before it. While only a few people were on hand for the recording, a community generated the circumstances for this song to be created—and for a larger audience to hear it. Not only had the Great Migration from the South dramatically boosted the black population of this midwestern city, but the Impressions’ generation forged an identity through music. Diverse circumstances strengthened Chicago-area teen culture during the 1950s and 1960s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en7",
      "id": "en7r"
    }
  }, [_vm._v("6")])]), _vm._v(" Songs frequently arose within the hallways of public housing projects or schools, places full of teens with plenty of ideas, and varying religious denominations informed young singers’ vocal training and inflections. The process of recording “For Your Precious Love” also reflected bigger changes. This single was cut for an African American–owned company, Vee-Jay, that was a landmark operation but not the only one of its kind. Emerging radio personalities provided airtime for records like these and spoke the same dialect as their listeners. These media voices would promote new economic resources and political advances as eagerly as they broadcast R&B hits. The real financial beneficiaries of these developments would always be questioned—these were commercial enterprises, not social missions. But whether or not everyone acted in harmony, and even if a burgeoning movement did not yet have a name, this record announced a push forward."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en8",
      "id": "en8r"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', [_vm._v("On the eve of the civil rights movement in the 1950s, many Chicagoans had a great deal to push against. Schools in African American communities faced overcrowding and other entrenched difficulties. Barriers to equal employment were visible throughout the city; Butler remembers walking "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p7"
    }
  }), _vm._v("downtown and seeing signs that barred blacks from applying even for dishwashing jobs. His memoir describes the racism he encountered as a student at Washburne Technical High School, a vocational institution near Cabrini-Green."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en9",
      "id": "en9r"
    }
  }, [_vm._v("8")])]), _vm._v(" He knew that the program could take him only so far, since white-dominated unions ran apprentice programs specifically to keep blacks out of skilled trades."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en10",
      "id": "en10r"
    }
  }, [_vm._v("9")])]), _vm._v(" Butler, like other black musicians from his generation, remained steadfast.")]), _vm._v(" "), _c('p', [_vm._v("Black musicians who came of age in Chicago from the 1950s through the 1970s usually were either part of or not far removed from the mass movement of hundreds of thousands of African Americans who left the South for the Midwest’s largest city. As journalist Isabel Wilkerson noted in "), _c('i', [_vm._v("The Warmth of Other Suns")]), _vm._v(", the Illinois Central Railroad “carried so many southern blacks north that Chicago would go from 1.8 percent black at the start of the twentieth century to one-third black by the time the flow of people finally began to slow in 1970.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en11",
      "id": "en11r"
    }
  }, [_vm._v("10")])]), _vm._v(" By the 1950s, moreover, these new Chicagoans would “arrive with higher levels of education than earlier waves of migrants and thus greater employment potential than both the blacks they left behind and the blacks they joined.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en12",
      "id": "en12r"
    }
  }, [_vm._v("11")])]), _vm._v(" They also tended to have more education than the city’s white immigrant arrivals."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en13",
      "id": "en13r"
    }
  }, [_vm._v("12")])]), _vm._v(" Parents sought to pass this advantage on to their offspring, although they faced institutional barriers within a school system that was 90 percent segregated by 1957 (and remained so sixty years later, when the city’s public school students were 47 percent Latino, 37 percent African American, and 10 percent white)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en14",
      "id": "en14r"
    }
  }, [_vm._v("13")])]), _vm._v(" As the National Association for the Advancement of Colored People (NAACP) reported, “In cost and quality of instruction, school time, districting and choice of sites, the Chicago Board of Education maintains in practice what amounts to a racially discriminatory policy.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en15",
      "id": "en15r"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', [_vm._v("The fight against discrimination became as internal as it was organizational. Leon Forrest, who grew up on the South Side in the 1940s and 1950s, argued that his family and neighbors took on structural disadvantages through survival strategies and mutual support systems. In his essay collection "), _c('i', [_vm._v("Relocations of the Spirit")]), _vm._v(" he wrote, “More than anything else we believed that the individual had to find something within himself, some talent, moxie, intelligence, magical nerve, swiftly developed skill, education, knack, trade, or underground craft and energize it with the hustler’s drive.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en16",
      "id": "en16r"
    }
  }, [_vm._v("15")])]), _vm._v(" Indeed, these are qualities that most musicians have needed. But black artists in Chicago who developed these attributes could also rely on some reinforcement.")]), _vm._v(" "), _c('p', [_vm._v("While Forrest illustrates how such performers had to build such qualities "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p8"
    }
  }), _vm._v("from within, some institutional support also existed for the kind of education he mentioned, and many times that came down to committed faculty. Families of young musicians in Chicago sought out the high schools in African American neighborhoods that had solid music programs and teachers who were more than adept. Saxophonist Willie Henderson and trombonist Willie Woods still credit the discipline they learned from band teacher Louis Whitworth at Wendell Phillips High School in Bronzeville. Captain Walter Dyett, who taught at Wendell Phillips and DuSable high schools from 1935 into the 1960s, became one of the most admired teachers. A graduate of VanderCook College of Music with a master’s degree from Chicago Musical College, Dyett’s students included Nat King Cole, saxophonists Johnny Griffin and Von Freeman (also an arranger at Vee-Jay), and many other jazz heroes. Dyett also taught future R&B musicians like violinist-turned-guitarist Bo Diddley and Morris Jennings, later a Chess Records session drummer."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en17",
      "id": "en17r"
    }
  }, [_vm._v("16")])]), _vm._v(" Many of these artists have commented on their teacher’s musical expertise, tough methods, and warm heart. His professional background and a supportive community embodied the qualities that later scholars of education would describe as essential."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en18",
      "id": "en18r"
    }
  }, [_vm._v("17")])]), _vm._v(" Another drummer, Marshall Thompson, who would switch to singing, added that Dyett’s pedagogy might seem unorthodox to some: “Capt. Walter Dyett started me off,” Thompson said. “He was one of the greatest musicians in the world. He’d throw that stick at you if you played the wrong note. He’d throw that stick right at your face. It was amazing, we had a thirty-piece orchestra and he could tell who was playing wrong.”")]), _vm._v(" "), _c('p', [_vm._v("Budding musicians also honed their skills through higher education. Between 1941 and 1964, the proportion of blacks who completed college rose from less than 2 percent to greater than 5 percent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en19",
      "id": "en19r"
    }
  }, [_vm._v("18")])]), _vm._v(" As part of this trend, in 1950s Chicago more college and postgraduate educational opportunities became available to African Americans. Roosevelt University was founded in 1945 as faculty left the city’s YMCA College to protest that institution’s quotas on black and Jewish students."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en20",
      "id": "en20r"
    }
  }, [_vm._v("19")])]), _vm._v(" By September 1954, Roosevelt could boast of a fall enrollment of 3,500 students in its schools of arts, sciences, commerce, and music."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en21",
      "id": "en21r"
    }
  }, [_vm._v("20")])]), _vm._v(" This was part of a local wave of 90,000 college students, including 11,600 in the city’s three junior colleges."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en22",
      "id": "en22r"
    }
  }, [_vm._v("21")])]), _vm._v(" Alabama-born James Mack was one such student. His classical music education included bachelor’s and master’s degrees from Roosevelt in the 1950s. During the next decade he would mentor a host of future R&B stars at Crane Junior College before becoming in demand as an arranger."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en23",
      "id": "en23r"
    }
  }, [_vm._v("22")])]), _vm._v(" Another arranger, Charles Stepney, attended Wilson Junior College and Roosevelt. In the late 1960s he would apply experimental compositional theories to R&B, blues, and rock."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en24",
      "id": "en24r"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0101"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p9"
    }
  }), _vm._v("Religious Foundations Reflect Multiple Sources")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Migrants and their children also heard or participated in older traditions, from blues to singing in the many churches on the West and South Sides. Curtis Mayfield and Jerry Butler had abundant experience with church music (Mayfield also expressed his admiration for blues musicians)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en25",
      "id": "en25r"
    }
  }, [_vm._v("24")])]), _vm._v(" Mayfield was born in Chicago in 1942, and a few months later Butler, at age three, arrived from Mississippi with his mother and father."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en26",
      "id": "en26r"
    }
  }, [_vm._v("25")])]), _vm._v(" As teens, both performed in Mayfield’s grandmother’s Traveling Soul Spiritualist Church. But while soul music is rooted in gospel, a common depiction of “the black church” as a single entity is misleading. The influence of Sanctified and Baptist shouts and rhythms on gospel and R&B has been described frequently, including in my previous book."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en27",
      "id": "en27r"
    }
  }, [_vm._v("26")])]), _vm._v(" But denominations in black Chicago represented a cosmopolitan mixture, as did the music that resulted from this diversity. These churches and their differences reflecting class, theology, and missions had expanded since the beginning of the Great Migration."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en28",
      "id": "en28r"
    }
  }, [_vm._v("27")])]), _vm._v(" Eugene Dixon, who would become known as Gene Chandler, sang in a Baptist choir. Marshall Thompson said that the Chi-Lites used Catholic liturgical singing as their model. The Flamingos, who formed on the South Side in 1952, belonged to the Church of God and Saints of Christ, which incorporated Jewish theological and musical influences in its services, and the group retained these minor-key refrains in its R&B ballads. Maybe these cries also reverberate in the eerily beautiful a cappella opening of the group’s “Golden Teardrops.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en29",
      "id": "en29r"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', [_vm._v("Dells singer Chuck Barksdale imitated the bass voices he heard in his church, but he also insisted that his group’s vibrant harmonies derived from a denominational cross-pollination. “I was raised Methodist, I became a Muslim,” Barksdale said. “Mickey McGill was a Seventh-Day Adventist, Marvin Junior was a Jehovah’s Witness, and Johnny Carter was Hebrew. So we had five different situations going on, but we never had an argument about our religions. Everything that God puts together is going to be right. Mathematics is exact.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en30",
      "id": "en30r"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', [_vm._v("Other musical influences from churches were not so straightforward. In north suburban Evanston, Patti Drew grew up singing in Mount Carmel Baptist and Bethel African Methodist Episcopal congregations. In the 1960s her jazz-inflected delivery shone on such hits as “Tell Him” and “Working on a Groovy Thing.” Drew claimed that since her style did not come unadulterated from a purely Baptist or Sanctified Gospel tradition of ecstatic spirituality, her work was not easy to market as hard soul. She said her approach also derived from the “very plain, very straight” style of her main childhood church, but she also said she admired jazz stylist Nancy Wilson.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p10"
    }
  }), _vm._v("Religious roots involved more than just singing or transforming the rhythms and phrasings of a traditional repertoire. Churches back then, and today, provided either a rudimentary musical education or a gateway to alternative music schooling. This offered a rich reservoir from which African American youths could claim more music as their own. As a child, Barbara Acklin sang in the New Zion Baptist Church choir and studied classical music there too, although she later mentioned preferring “soulful pop.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en31",
      "id": "en31r"
    }
  }, [_vm._v("30")])]), _vm._v(" Singer-songwriter Lowrell Simon’s experience in church furthered his education: his hearing another performer in the church prompted him to ask his grandmother, a housekeeper, to pay for voice lessons.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0102"
    }
  }, [_vm._v("Neighborhood Bonds and Collisions")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Even as young people, some migrants brought southern traditions with them, which became enhanced with urban sounds. Mississippi-born McKinley Mitchell sang gospel before he relocated to Chicago in 1958 and wrote “The Town That I Live In,” which a Record Row company, One-derful, released in 1962."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en32",
      "id": "en32r"
    }
  }, [_vm._v("31")])]), _vm._v(" His elongated vocal lines and call-and-response delivery reflected his gospel background, yet the accompaniment from a horn section featuring saxophonist-arranger Willie Henderson and jazz trumpeter King Kolax represented different musical strains that also thrived in Chicago. The song’s lyrics—which depict loneliness and dislocation—could have derived from migration and resonated among Latino immigrants in Southern California."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en33",
      "id": "en33r"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', [_vm._v("For the generation that grew up in and around Chicago, the South and its attitudes often seemed not far away. Singer Eddie Perrell attended the city’s McCosh Elementary School with Emmett Till, whose 1955 murder in Mississippi helped instigate the civil rights movement. Within Chicago, white resistance to African American migration and relocation took many forms. Lorraine Hansberry’s classic 1959 play "), _c('i', [_vm._v("A Raisin in the Sun")]), _vm._v(" drew on her family’s thwarted attempts to move into a white neighborhood in the 1930s. In Englewood on the South Side, crowds of angry whites vented their anger in 1949 when they only suspected a black family was moving into a home at Fifty-Sixth and Peoria."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en34",
      "id": "en34r"
    }
  }, [_vm._v("33")])]), _vm._v(" White mobs continued to use arson and other acts of terrorism in trying to block integration of other South Side neighborhoods such as Park Manor."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en35",
      "id": "en35r"
    }
  }, [_vm._v("34")])]), _vm._v(" Unscrupulous land speculators bought properties cheaply from white owners and sold them to black purchasers at inflated prices."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en36",
      "id": "en36r"
    }
  }, [_vm._v("35")])]), _vm._v(" In 1948 the United States Supreme Court struck down the practice of white property owners’ using restrictive covenants to prevent blacks from buying homes: "), _c('i', [_vm._v("Tovey v. Levy")]), _vm._v(" centered on the purchase of a residential "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p11"
    }
  }), _vm._v("building in Englewood."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en37",
      "id": "en37r"
    }
  }, [_vm._v("36")])]), _vm._v(" But judicial fiat could not halt ongoing housing discrimination or white flight. As 50,000 whites left that neighborhood, its black population rose from 11 percent to 70 percent over the 1950s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en38",
      "id": "en38r"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', [_vm._v("Yet some African American artists who grew up in Englewood convey benign reflections. Speaking with them evoked not nostalgia, but a candid account of how they made connections within this time and place. Saxophonist Roscoe Mitchell said that at Englewood High School he was mentored on his instrument by the slightly older Don Myrick, years before they made their names in jazz and R&B."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en39",
      "id": "en39r"
    }
  }, [_vm._v("38")])]), _vm._v(" Another singer, Jackie Ross, moved to Chicago with her mother, a gospel radio disc jockey in St. Louis, on the advice of family friend Sam Cooke. For her, Englewood was a step up from worse poverty, and white flight appeared not so burdensome. After a disastrous stay in the South Side’s Washington Park area, the two of them rented an Englewood apartment from a Jewish family that vacated but left furniture behind. Still, Ross envisioned marriage as offering no relief from financial struggles when she wrote the witty “Hard Times,” which she recorded in 1962 for Cooke’s SAR label.")]), _vm._v(" "), _c('p', [_vm._v("Gene Chandler recalled that prejudice in and around Englewood was visible then, but it seemed more a vestige than an inhibiting force. He had other concerns.")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("When I went to Englewood, it was majority white. I was twelve years old. It was probably ’52. My family decided to go to Englewood, and that’s what we did. We had racial problems, yeah. I remember there was a club there about a block from me, and they put up signs, “For Members Only” to try to keep the black people out. Well, of course, I wasn’t going into lounges anyway at that time. And it was soon changing; I think they ended up leaving the neighborhood or whatever the case might have been. So the usual racial conflicts were going on, and that was it. So I came through that. I came through the gangs because I was one of the gangs. We called ourselves the Latin Lovers. Because we didn’t go out there to fight. We just enjoyed being around each other. But there were times we had to fight somebody just to let them know that we weren’t punks.")])]), _vm._v(" "), _c('p', [_vm._v("Forming such bonds crossed neighborhoods and genders. As a teen in north suburban Evanston, Patti Drew said she was part of an all-girl gang called the Latin Ladies."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en40",
      "id": "en40r"
    }
  }, [_vm._v("39")])]), _vm._v(" These were not outliers. British music historian Brian Ward compared the cohesion within black American vocal groups to that of street gangs as social institutions that often shared membership in the 1950s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en41",
      "id": "en41r"
    }
  }, [_vm._v("40")])]), _vm._v(" But neither Chandler’s nor Drew’s affiliations back then were much more than small, informal clubs.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p12"
    }
  }), _vm._v("Young performers also responded to a range of social situations just outside Chicago. In Evanston, Drew liked a combination of informal venues: along with the churches, she sang with the Evanston Township High School glee club and, at the behest of her gang, performed at Big Herm’s fast food shack."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en42",
      "id": "en42r"
    }
  }, [_vm._v("41")])]), _vm._v(" Arranger Johnny Pate grew up in Chicago Heights, thirty-one miles straight south of the city, during the 1930s and 1940s. He offhandedly described it as “sort of a segregated town, divided into sections. There wasn’t a lot of discrimination; we all went to school together.” The Dells (formed in 1952 as the El-Rays) started singing as teenagers in south suburban Harvey. For them, perceived class differences more than racial prejudice could have prevented their career from happening."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en43",
      "id": "en43r"
    }
  }, [_vm._v("42")])]), _vm._v(" Their families did not encourage singing as a career move.")]), _vm._v(" "), _c('p', [_vm._v("Artists pass through strata that their neighbors cannot penetrate, which was as true in the late 1950s as it is today. No whites-only signs were displayed in theaters, and artists were often able to work around the existing system of divided musicians’ unions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en44",
      "id": "en44r"
    }
  }, [_vm._v("43")])]), _vm._v(" But their determination to succeed should not be taken as evidence that perseverance is the surest path to overcoming serious obstacles, as current pop psychology attests."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en45",
      "id": "en45r"
    }
  }, [_vm._v("44")])]), _vm._v(" Many young people who experienced segregation did not see themselves as victims, despite the legal and unlawful forces that disenfranchised them. Musical excellence as a means of transcendence was just one response."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en46",
      "id": "en46r"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0103"
    }
  }, [_vm._v("Sounds of Public Housing")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Chicago public housing increased in scale during the 1950s. The creation and legacy of the housing projects remain contentious, since crime, decay, and other social ills became their typically described characteristics. Also, historians have noted that political and other pressures prevented these public homes from being built in white areas, including a white-led race riot at Trumbull Homes in the South Deering neighborhood in 1953."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en47",
      "id": "en47r"
    }
  }, [_vm._v("46")])]), _vm._v(" From 1954 through 1966, 99.4 percent of the Chicago Housing Authority’s 10,256 family units—all but 63—were in largely black neighborhoods."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en48",
      "id": "en48r"
    }
  }, [_vm._v("47")])]), _vm._v(" At the same time, CHA leaders constantly found themselves facing an indifferent, if not hostile, city council that resisted attempts to request more federal funding."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en49",
      "id": "en49r"
    }
  }, [_vm._v("48")])]), _vm._v(" Nonetheless, at least during the first years of the CHA expansion, former CHA residents contend that the complexes “created a strong sense of community,” as social welfare policy professor J. S. Fuerst noted."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en50",
      "id": "en50r"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', [_vm._v("In terms of artistic output the most famous example of these projects was the Frances Cabrini Homes, which became Cabrini-Green. The original row houses were built in 1942 on seventy acres just southwest of the major "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p13"
    }
  }), _vm._v("three-way intersection of North and Clybourn Avenues and Halsted Street, somewhat close to downtown. Planned as a model for an integrated neighborhood of working-class families, the site was built in a largely Italian enclave."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en51",
      "id": "en51r"
    }
  }, [_vm._v("50")])]), _vm._v(" About the time the Impressions walked down Record Row, larger high-rise buildings were constructed in their neighborhood, which had become predominantly African American."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en52",
      "id": "en52r"
    }
  }, [_vm._v("51")])]), _vm._v(" Along with Butler and Mayfield, Cabrini-Green was home to an incredible concentration of future singers, including Otis Leavill, Major Lance, Terry Callier, and Larry Wade. Butler recounts in his memoirs that he did not really notice its “filth and dirt” before touring nationally with the Impressions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en53",
      "id": "en53r"
    }
  }, [_vm._v("52")])]), _vm._v(" In a 2016 conversation he mentioned that while he was living in Cabrini, he and the people around him had other concerns: “Everyone sees their conditions differently,” Butler said. “I didn’t realize that I was poor because everybody in the neighborhood was poor. So you didn’t think about how poor you were, you just thought about, ‘What am I going to do to succeed?’ That was where we came from.”")]), _vm._v(" "), _c('p', [_vm._v("After Mayfield spent his childhood moving across the city with his mother and four siblings as they struggled against poverty, he said settling in Cabrini-Green “seemed like the greatest place in the world.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en54",
      "id": "en54r"
    }
  }, [_vm._v("53")])]), _vm._v(" Fuerst describes how CHA-sponsored events at that time fostered a sense of community through activities geared toward young people."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en55",
      "id": "en55r"
    }
  }, [_vm._v("54")])]), _vm._v(" He added that initially the CHA also had leaders who seemed concerned about the tenants’ general welfare."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en56",
      "id": "en56r"
    }
  }, [_vm._v("55")])]), _vm._v(" The idea of public housing as a means to encourage the kind of life that could make creating music possible came from the top down as well as from the aspiring singers. And as journalist Ben Austen described in "), _c('i', [_vm._v("High-Risers")]), _vm._v(", his book about Cabrini-Green, the residents often took it upon themselves to organize events in the community and to look out for each other’s well-being, as Butler’s former neighbor, Delores Wilson, did."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en57",
      "id": "en57r"
    }
  }, [_vm._v("56")])]), _vm._v(" But these reflections were not limited to this well-documented project: vocalist Bobby Hutton had warm memories of growing up in the Far South Side’s Altgeld Gardens at that time, as did singer Maurice Jackson, whose family moved there when he was two years old. Jackson even recalled that in the 1950s it was “a paradise for black people.”")]), _vm._v(" "), _c('p', [_vm._v("In contrast to the South Side and Cabrini Green, the West Side had long been comparatively bereft of organized recreation or social activities. That part of town had no equivalent of such venues as Bronzeville’s 3,000-seat Regal Theater at Forty-Seventh Street and South Parkway. Sociologist Allan Spear wrote in 1967 that as far back as 1908 “this neighborhood had lagged behind the South Side in institutional development.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en58",
      "id": "en58r"
    }
  }, [_vm._v("57")])]), _vm._v(" Singer Mitty Collier, now a pastor, believes the differences between the South Side and West Side have continued. Her recollection also hints at class distinctions: “They were "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p14"
    }
  }), _vm._v("more glamorous on the South Side than on the West Side,” Collier said. “Even now, I go over there to preach and even the people in church on the West Side is more southern atmosphere, country. Like when we’d play the chitlin’ circuit and all the clubs were back off the road, off the highway, in the back with trees. The people who come to those clubs are like people on the West Side. When you got to the better upscale clubs, they were like people on the South Side.”")]), _vm._v(" "), _c('p', [_vm._v("But aspiring performers on the West Side also used what they had to their benefit. Schools were one example, even with the system’s inherent and ongoing inequalities. Bassist Bernard Reed learned how to read music during a Marshall High School summer program and looked up to the neighborhood’s drum and bugle corps. In the mid-1950s future label executive Emmett Garner enjoyed singing competitions at Marshall, which guitarist Phil Upchurch attended too. Singer Marvin Smith, who also grew up on the West Side and attended Crane Tech High School, voiced similar sentiments: “I loved high school,” Smith said. “When I went to school, there were a lot of singers around. We would sing in the corridors where you get the echo. Then when you sing in a vocal group, or just some guys getting together, you’re going to attract a crowd. Once you attract a crowd, the pretty girls are coming around. Just like the basketball players and hockey players—we were stars around school.”")]), _vm._v(" "), _c('p', [_vm._v("Other entrepreneurs and institutions assisted young people on the West Side well into the next decades, sometimes unintentionally. Singer-songwriter Gavin Christopher said the blues bar Silvio’s provided him with an alternative to the jazz vocal albums his uncle preferred during the mid-1950s. At about five years old, nowhere near old enough to go out drinking, he remembered listening to Sunnyland Slim and Koko Taylor outside the club during recess at his school.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0104"
    }
  }, [_vm._v("Emerging Voices Recharge Radio")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Radio connected the city and became an electronic forum throughout Chicagoland. Records cost money, and 1950s television, for those who owned sets, showed scant representation of African Americans."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en59",
      "id": "en59r"
    }
  }, [_vm._v("58")])]), _vm._v(" Nearly every home had a radio, and the Federal Communications Commission allowed smaller stations to boom after World War II, with 200 to 1,000-watt stations going up fivefold from 1946 to 1951."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en60",
      "id": "en60r"
    }
  }, [_vm._v("59")])]), _vm._v(" Nationwide, the number of stations in the country airing black programming went from twenty-four in 1946 to nearly six hundred by 1955."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en61",
      "id": "en61r"
    }
  }, [_vm._v("60")])]), _vm._v(" In Chicago, black voices had been on the air decades earlier. In 1929 Jack L. Cooper became a DJ on station WSBC. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p15"
    }
  }), _vm._v("He went on to start the first African American daily news broadcast, which amassed national advertising."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en62",
      "id": "en62r"
    }
  }, [_vm._v("61")])]), _vm._v(" And Cooper’s ambitions extended outside the broadcast booth. He advocated for such causes as exhorting Dean’s Milk to hire more black truck drivers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en63",
      "id": "en63r"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', [_vm._v("An upcoming generation of black radio personalities used their voices in the studio to signify change. Above all, they brought a speaking style that mirrored their local audience. Al Benson became the prime example. Previously known as Rev. Arthur Leaner, Benson played a mix of new jazz, blues, and R&B in the early 1950s, as his nephews George and Ernie Leaner helped him pick records from their Groove Record Shop in Bronzeville. On station WGES the Mississippi native spoke in what was recognized as a black American dialect, with its southern inflections."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en64",
      "id": "en64r"
    }
  }, [_vm._v("63")])]), _vm._v(" Cooper, by contrast, spoke with more proper enunciation. The change carried cultural currency. Norman Spaulding’s history of black radio in Chicago notes “the intermixture of Benson’s southern style with the northern middle-class style that evolved into a Black urban language.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en65",
      "id": "en65r"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', [_vm._v("While Benson’s dialect attracted northern listeners, these audiences’ musical preferences were changing, and local media started to go along with them. WBEE host Gregg Harris wrote in a "), _c('i', [_vm._v("Chicago Defender")]), _vm._v(" column on April 1, 1958, that he would ignore idiom boundaries and simply play “good music.” He declared, “If you want to call it rock and roll, jazz, blues, ‘pop’ or whatever, that’s your business. To me, it will be music and it will be good; it will also faithfully reflect what you indicate you want (by your letters and purchases) to hear.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en66",
      "id": "en66r"
    }
  }, [_vm._v("65")])]), _vm._v(" The station also engaged in political and consumer activism, including airing a lengthy interview with a Chicago Urban League official, and it conducted surveys on the buying power of South Side consumers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en67",
      "id": "en67r"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', [_vm._v("Benson also hosted talent contests throughout the city, and clubs and high schools ran smaller versions. These events served as relatively egalitarian spaces for young performers, many of whom had more talent than connections. But Benson’s competitions at the Regal Theater were the biggest. Mitty Collier entered a Benson-run event in 1959 as an eighteen-year-old college student from Alabama with a stunning contralto voice. As Collier related, Benson’s ideals and business acumen were not mutually exclusive. After she won the talent show and received its prize of opening for Etta James and B. B King, in 1960 the DJ introduced her to a Chess Records talent scout. After numerous strong efforts, her hit singles followed three years later."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en68",
      "id": "en68r"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', [_vm._v("Most likely a few underhanded favors were also exchanged between radio heavyweights and record companies. Later Benson would reveal to federal "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p16"
    }
  }), _vm._v("investigators that in 1960 he had been receiving roughly $1,000 a month from record companies."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en69",
      "id": "en69r"
    }
  }, [_vm._v("68")])]), _vm._v(" Yet the money Benson accepted was just a part of his overall operation, according to one of his younger followers, WGES DJ Moses “Lucky” Cordell, who also arrived in Chicago from Mississippi. As Cordell told documentary maker Michael McAlpin, Benson had a true power to persuade on a higher commercial level: “Up to the point of his demise in broadcasting Al Benson called his own shots,” Cordell said to McAlpin. “If you were going to reach the black community in Chicago, you had to come through Al Benson. . . . He talked to Coca-Cola and people of that size like they were children.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en70",
      "id": "en70r"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', [_vm._v("For some struggling young singers, such clout was not so endearing. Vocalist Millard Edwards from the Sheppards and the Esquires considered Benson a bully for his enforced favoritism. Chuck Barksdale of the Dells just called him a crook. Still, it would have been difficult for a completely honest person to exist in that field—underhanded dealings in the music industry arose long before the first radio transmission."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en71",
      "id": "en71r"
    }
  }, [_vm._v("70")])]), _vm._v(" Although both black and white radio programmers and employees received illicit payments for airplay, sometimes it was a matter of survival. As "), _c('i', [_vm._v("Billboard")]), _vm._v(" stated, “Black DJs often lived in squalor, earning as little as $30 a week in the ’50s when payola wasn’t illegal. It seemed as natural to pay DJs to play the records as it was to pay artists to record them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en72",
      "id": "en72r"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', [_vm._v("Benson’s aggressive entrepreneurship crossed over into personal and unconventional political advocacy, which did not always profit him. In February 1956 (on George Washington’s birthday), the DJ hired a plane to drop copies of the US Constitution on the Mississippi state capitol. Benson said he sought to penetrate “the Ironic Curtain of racial hatred and prejudice against Negroes in one of the forty-eight sovereign states of America.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en73",
      "id": "en73r"
    }
  }, [_vm._v("72")])]), _vm._v(" He also integrated the Chez Paree nightclub, a 650-seat downtown venue that presented such postwar popular entertainers as Tony Bennett and Sammy Davis Jr. Benson and a group staged a sit-in and refused to leave until African American patrons were treated with respect."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en74",
      "id": "en74r"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', [_vm._v("Not long afterward, another crucial event at the Chez Paree unfolded not in its show room, but in its outdoor parking lot. Eddie Thomas had a job parking cars there about the time Benson staged his demonstration. Born in 1931, Thomas had been accepted into West Point, but his stepfather, blues pianist “Big Maceo” Merriweather, suffered a stroke in 1946, and Thomas had to take on a series of jobs to support his mother."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en75",
      "id": "en75r"
    }
  }, [_vm._v("74")])]), _vm._v(" “One evening in August I was parking cars and five kids from Cabrini-Green came over there,” Thomas said. “They were looking for the manager, and since I was the only black person there parking cars at night, they came to me directly. And they "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p17"
    }
  }), _vm._v("said, ‘Can you help us? We want to see the manager and be on the show with Sammy Davis Jr.’ I said, ‘I can’t get to him right now because he’s very busy, can you come back tomorrow?’ I hoped they wouldn’t come back [smiles], and bang, there they were the next night.”")]), _vm._v(" "), _c('p', [_vm._v("That group, the Medallionaires, rehearsed in Cabrini-Green’s Seward Park recreation center. This field house offers fine acoustic qualities, specifically the way isolated vocals echoed through its gymnasiums and practice rooms, even sixty years later."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en76",
      "id": "en76r"
    }
  }, [_vm._v("75")])]), _vm._v(" Thomas did become their manager, but when he saw them perform at a talent show, he noticed another Cabrini-Green–based group that beat them: the Roosters, who also practiced at Seward. Along with Jerry Butler and Curtis Mayfield, Tennessee-born singers Arthur and Richard Brooks made up the ensemble. Not lacking in aplomb, Thomas took them to the jazz club Mister Kelly’s on North Rush Street in the posh Gold Coast neighborhood, where they could try out their music in front of a contrastive audience—even though the venue was just a short drive away from Cabrini. Thomas also suggested a name change to reflect their urbane aspirations: “I ended up managing the Roosters, and I said, ‘You guys got a beautiful sound, you won the contest, but you should change your name. When I met you, I was very impressed with your sound, so why not change your name to the Impressions?’ Everybody was doing doo-wops, but they had something like a musical choir in the background.”")]), _vm._v(" "), _c('p', [_vm._v("That choral intoning was intentional. The Impressions’ harmonies on “For Your Precious Love” remained close to the gospel quartet tradition, but true spirit came from inside them. The song’s basic elements do not deviate much from contemporary tunes that would have been part of the late 1950s radio playlists and jukeboxes: played in the key of C, it slowly descends and ascends among four chords (C, A-minor, F, and G). This chord progression (I–vi–IV–V) would commonly be called “ice cream changes” by more seasoned musicians as a slam on its seeming simplicity. But what made the song so distinctive was the way it was delivered. Butler’s baritone avoided obvious highs and lows while conveying deep, quiet persuasion. Nor did the melody lose anything by not having an obvious hook (say, a middle eight in a thirty-two-bar form). As author Leon Forrest’s bartender-playwright Joubert Jones narrates in his 1992 novel "), _c('i', [_vm._v("Divine Days")]), _vm._v(" (set in Chicago in 1966), “For Your Precious Love” can be pinpointed as the “first urban Soul song. . . . Slick, sleek too, ultra smooth, celebratory, sincere and foxy. Ice.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en77",
      "id": "en77r"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', [_vm._v("Butler agreed that “For Your Precious Love” stood apart from the up-tempo tunes of the time, and that may have come from his method. He wrote the words at age sixteen as a kind of tone poem, with Arthur and Richard Brooks adding contributions to the melody. “I don’t think I wrote a lot "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p18"
    }
  }), _vm._v("of poems, but I wrote a few,” Butler said. “I was always interested in poetry. My mother always pushed poetry as a way of getting you to do something in public, and to recite poetry was that thing. And out of that, songwriting developed. That was our intent, to write something different [from other doo-wop songs]. When you listen to it, you hear that it was a poem—probably an ode would be the correct category.”")]), _vm._v(" "), _c('p', [_vm._v("Actually big enough to sound beyond any category, the song sat in the group’s pocket as the Impressions hit Record Row.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0105"
    }
  }, [_vm._v("New Record Labels Capture Youthful Sounds")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Vee-Jay released “For Your Precious Love” in June 1958, and it ascended to number seven on the "), _c('i', [_vm._v("Billboard")]), _vm._v(" R&B chart and number eleven on the pop listing."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en78",
      "id": "en78r"
    }
  }, [_vm._v("77")])]), _vm._v(" Competition proved equally intense locally and nationally as small Chicago record companies found growing audiences. These businesses also drew on a young talent pool for staff, such as Vee-Jay’s recruiting ace teenage guitarist Phil Upchurch."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en79",
      "id": "en79r"
    }
  }, [_vm._v("78")])]), _vm._v(" Although Vee-Jay and Chess were rivals, their emergence (Vee-Jay in 1953, Chess in 1950) arose from similar forces. Chicago’s record industry dates back to the 1920s, with Paramount, Brunswick, Okeh, Decca, and Victor issuing jazz and blues artists."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en80",
      "id": "en80r"
    }
  }, [_vm._v("79")])]), _vm._v(" Independent companies filled a pent-up demand for new music after World War II, and they were quicker than major labels."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en81",
      "id": "en81r"
    }
  }, [_vm._v("80")])]), _vm._v(" Mercury, which went into business in 1945, ran its own pressing plants."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en82",
      "id": "en82r"
    }
  }, [_vm._v("81")])]), _vm._v(" In this environment Leonard and Phil Chess (Poland-born Jews who immigrated to Chicago as children) and the African American married couple Vivian Carter and Jimmy Bracken who started Vee-Jay were not outsiders.")]), _vm._v(" "), _c('p', [_vm._v("During the 1950s, the stretch of Michigan Avenue that had been home to car dealerships became the epicenter of the city’s record industry. In the late 1950s, Chess moved to 2120 South Michigan Avenue, and Vee-Jay sat nearby at 2129. Vivian Carter had come to know the street well, since she won an Al Benson talent contest and in 1948 hosted a radio show as a prize."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en83",
      "id": "en83r"
    }
  }, [_vm._v("82")])]), _vm._v(" After working in a millinery shop, during the early 1950s she went back to pursue a career in radio in northwest Indiana."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en84",
      "id": "en84r"
    }
  }, [_vm._v("83")])]), _vm._v(" When she and Bracken established Vivian’s Record Shop in Gary, they befriended Ewart Abner, who ran a record company. Abner told musicologist Portia Maultsby that he gave the couple the idea of starting their own company and offered to help them, bringing his earlier experience in establishing a label called Chance with Art Sheridan."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en85",
      "id": "en85r"
    }
  }, [_vm._v("84")])]), _vm._v(" A few years later, Sheridan helped back Vee-Jay."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en86",
      "id": "en86r"
    }
  }, [_vm._v("85")])]), _vm._v(" Another assist came from a pawnbroker who loaned Vivian and Jimmy $500."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en87",
      "id": "en87r"
    }
  }, [_vm._v("86")])]), _vm._v(" Still, Butler recalled Abner as the real energy fueling these efforts. He described him as "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p19"
    }
  }), _vm._v("“one of the smartest guys who ever went into the record business. He came to the record business with the attitude ‘I want to be big.’ And he did that by recording all types of music.”")]), _vm._v(" "), _c('p', [_vm._v("While the Vee-Jay founders relied on that small network of supporters, they continued to fight inequities. The company struggled to establish its voice in an industry that saw whites in charge of not just the record companies, but also banks, credit agencies, and other firms that make business possible."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en88",
      "id": "en88r"
    }
  }, [_vm._v("87")])]), _vm._v(" Vee-Jay’s existence encouraged others, according to singer Shirley Wahls, who recorded for the company with the gospel group the Argo Singers. She remembered Vee-Jay as essentially the only significant black business of any kind that she encountered at that time, aside from small retail stores.")]), _vm._v(" "), _c('p', [_vm._v("Nevertheless, these companies were not in the business merely to document and present great art or to build communities. They knowingly entered a system that depended on capital, and resources were not usually dispensed altruistically. Hints abound that Vee-Jay took part in this deviousness. For instance, company executive Calvin Carter’s name appears before that of singer-songwriter James Hudson as the cowriter on the Spaniels’ 1954 hit “Goodnight, Sweetheart, Goodnight.” How much of the song, if any, Carter wrote remains anybody’s guess. Since producers, managers, and radio personalities typically found ways to add their names to compositions as coauthors, Vee-Jay management was engaging in a standard practice. DJ Herb Kent uses harsher words to describe Vee-Jay’s business moves in his 2009 memoir, yet he provides no details about the company’s malfeasance."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en89",
      "id": "en89r"
    }
  }, [_vm._v("88")])]), _vm._v(" Creative bookkeeping likely was in force at Vee-Jay when Butler, Mayfield, and the rest of the Impressions visited its office, even if there was indeed no tape recorder hidden in a drawer. There’s just no way to put a definitive amount on how much any record company unfairly appropriated from artists. “They probably took advantage of us because we didn’t know any better,” Butler said. “And they didn’t feel that they were hurting us because they were giving us an opportunity to be what we wanted to be. So it was fair exchange.”")]), _vm._v(" "), _c('p', [_vm._v("New technology also shaped those records during the late 1950s, especially at Chicago’s Universal Recording Corporation on the Near North Side. Most of Vee-Jay’s tracks were recorded at Universal, as were thousands of others from companies across the city. Engineer Bruce Swedien, who began at Universal in 1957, discusses these changes in his 2009 memoir, "), _c('i', [_vm._v("Make Mine Music")]), _vm._v(". Swedien notes that when they began in the studios he and his contemporaries improved the clarity of musical instruments through such ideas as acoustic separation screens. Engineers experimented with placing "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p20"
    }
  }), _vm._v("microphones. The idea was to create a singular recorded sound rather than to duplicate a concert performance. A few engineers, including Swedien, looked into stereo recording that was more sophisticated than just reproducing what emanated from two speakers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en90",
      "id": "en90r"
    }
  }, [_vm._v("89")])]), _vm._v(" This was at a time when business media projected a boom in sales of high-fidelity recordings and major companies based in New York also investigated stereo for classical LPs."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en91",
      "id": "en91r"
    }
  }, [_vm._v("90")])]), _vm._v(" In October 1958 the "), _c('i', [_vm._v("Chicago Tribune")]), _vm._v(" reported, “Industry optimists, anticipating a new billion dollar market, predict that sales of stereo recording equipment, only 100,000 units in 1956, will reach the 725,000 rate by 1960. This would mean a dollar volume of some 300 million dollars.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en92",
      "id": "en92r"
    }
  }, [_vm._v("91")])]), _vm._v(" Even so, stereo recording for R&B records in Chicago remained a few years away.")]), _vm._v(" "), _c('p', [_vm._v("As Butler remembered the recording of “For Your Precious Love,” the configuration was simple: the Impressions’ four voices, with accompaniment solely from Mayfield’s guitar, bassist Quinn Wilson, pianist Horace Palm, and drummer Al Duncan. No sweeping orchestrations sweeten the sound. Those recent advances in studio innovation may have contributed to the sharpness of the instrumental section. An unadorned lineup was not uncommon for Vee-Jay sessions. Abner told Maultsby that gospel and blues groups came into the studio with their identifiable sound intact, so he and Calvin Carter would leave them to their work."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en93",
      "id": "en93r"
    }
  }, [_vm._v("92")])]), _vm._v(" The results supported them.")]), _vm._v(" "), _c('p', [_vm._v("That independence afforded to artists would continue in part because more African Americans in Chicago started their own music firms and obtained executive positions in larger operations. But the key is a sense of mutualism throughout these communities. Vee-Jay, and the Impressions’ record for the company, embodied these essential connections, drawn from such institutions as schools, churches, and radio stations. Musical tastes were evolving, with a new generation growing up at the end of the Great Migration, but the passed-down traditions—jazz, blues, gospel—continued to inform younger artists in the years to come.")]), _vm._v(" "), _c('p', [_vm._v("A big national change in R&B had emerged before all of this occurred. Artists’ and small companies’ hopes of receiving money for public airplay of their works became more attainable with the launch in 1940 of music publisher Broadcast Music, Incorporated (BMI). With BMI, songwriters in previously marginalized idioms such as R&B found a firm likely to be more amenable than the older American Society of Composers, Authors, and Publishers (ASCAP)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en94",
      "id": "en94r"
    }
  }, [_vm._v("93")])]), _vm._v(" At that time BMI promised a more equitable fee structure for its members who were played on the radio, as opposed to ASCAP’s paying more to better-known artists."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en95",
      "id": "en95r"
    }
  }, [_vm._v("94")])]), _vm._v(" Curtis Mayfield and Jerry Butler would become affiliated with BMI."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en96",
      "id": "en96r"
    }
  }, [_vm._v("95")])]), _vm._v(" This shift may have informed an article about a nationwide trend that received some attention in Chicago. As Hilda See "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p21"
    }
  }), _vm._v("wrote in the March 12, 1955, edition of the "), _c('i', [_vm._v("Chicago Defender")]), _vm._v(", African Americans were achieving wider popularity as composers. She expressed concern about “ofays [whites] who are moving into the field.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en97",
      "id": "en97r"
    }
  }, [_vm._v("96")])]), _vm._v(" See did not mention the rise of BMI, although she seemed to be alluding to it with her contention that black songwriters no longer had to be concerned about the dominance of songs from more exclusive Broadway and Hollywood hit factories. But with the wider popularity of traditionally black R&B, See concluded by warning about the potential encroachment of “white writers moving in on a field that began with the Sepians [blacks].”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chicohenmove0018#en98",
      "id": "en98r"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', [_vm._v("Maybe the future Impressions read See’s article. It’s anybody’s guess if her concerns entered the consciousness of black youths like Mayfield and Butler. These young men were just beginning to respond.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1f07b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-cohen-move-0007.vue
// module id = 72
// module chunks = 0